<template>
	<div class="supplier-sales">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Detail Sales</h1>
				<div class="page-header-right text-right ml-a">
				</div>
			</div>
			<div class="page-content mt-4">
				<!-- Table Menu -->
				<div class="sales-info col-md-5 mb-3" v-if="!isFetching && selectedSales">
					<div class="row well d-flex align-items-center">
						<div class="col-auto">
							<span class="icon-sales text-primary">
								<i class="bi bi-person-lines-fill"></i>
							</span>
						</div>
						<div class="col px-0">
							<div class="sales-name">{{ selectedSales.name }}</div>
							<div class="email-style">{{ selectedSales.email }}</div>
						</div>
						<div class="col-auto">
							<div class="total-label">Total Seller</div>
							<div class="fs-16 text-primary text-bold">{{ seller_count }}</div>
						</div>
					</div>
				</div>
				<shimmer v-if="isFetching" class="mb-4" width="35%" height="70px"/>
				<div class="row">
					<div class="col-12 d-flex justify-content-start mb-2">
						<!-- Search Keyword -->
						<input type="text" class="input form-control form-control-sm users-search-bo w-25"
						placeholder="email / username seller" autocomplete="off" v-model="keyword" @input="onKeywordChange"/>
					</div>
				</div>
				<div class="user-seller-list table-responsive">
					<table class="user-seller-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th width="25%" class="text-left">
									ID Seller
								</th>
								<th width="20%" class="th-sort text-left" :class="sortClass('name')"
									@click="changeSorting('name')">
									Nama
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('email')"
									@click="changeSorting('email')">
									Email
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in items" :key="index">
								<td>
									<span @click="copyId(item._id.$oid)" role="button">
										{{ item._id.$oid }}
									</span>
								</td>
								<td>
									<div class="name">
										{{ item.name }}
									</div>
								</td>
								<td>
									{{ item.email }}
								</td>
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Seller Found yet.</span>
						<span v-else>No Seller was found</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	formatDate,
	copyToClipboard,
	getAxiosErrorMessage,
} from '@/lib/helper';
import adminApi from '@/api/admin';
import shimmer from '@/components/Shimmer.vue';

export default {
	name: 'AdminSales',
	components: {
		shimmer,
	},
	data() {
		return {
			limit: 25,
			page: 1,
			sort_by: 'created_at',
			sort: 'desc',
			isFetching: false,
			isAll: false,
			items: [],
			selectedSales: null,
			keyword: null,
			selectall: false,
			seller_count: 0,
		};
	},
	methods: {
		resetItems() {
			this.items = [];
			this.page = 1;
		},
		countSeller(sales) {
			let count = 0;

			if (sales.seller_count) {
				count = sales.seller_count;
			}

			return count;
		},
		formatDate,
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			if (this.salesChanged) {
				params.sales_id = this.salesChanged._id;
			}

			if (this.keyword) {
				params.keyword = this.keyword;
			}

			return params;
		},
		fetchItems(reset = true) {
			const id = this.$route.params.sales_id;
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				this.isSearchingSupplier = false;
				const items = response?.data?.sellers;
				const selectedSales = response.data.sales;
				if (selectedSales) {
					this.selectedSales = selectedSales;
				}
				this.seller_count = response?.data?.page_info?.total_all_sellers;
				if (items?.length > 0) {
					this.page++;
					this.items = this.items.concat(items);
				} else {
					this.isAll = true;
				}
			};

			const errorCallback = (e) => {
				this.isFetching = false;

				const message = getAxiosErrorMessage(e);

				this.$notify({
					group: 'app',
					title: 'Detail Sales',
					text: message ?? 'Failed to Fetch Data',
					type: 'error',
				});
			};

			adminApi.getSalesDetail(id, params, callback, errorCallback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		copyId(item) {
			copyToClipboard(item);
			// toast notification
			this.$notify({
				group: 'app',
				title: 'ID Copied',
				text: item,
				type: 'success',
			});
		},
		onKeywordChange() {
			this.ooDelay(() => {
				this.fetchItems(true);
			}, 1000);
		},

	},
	created() {
		this.fetchItems();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
.icon-sales {
	font-size: 40px;
}
.fs-16 {
	font-size: 16px;
}
.fs-12 {
	font-size: 12px;
}
.sales-name {
	font-size: 14px;
	font-weight: 500;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
	color: #2E323D;
}
.email-style {
	font-size: 14px;
	font-weight: 400;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
	color: #80848E;
}

.bg-search {
	border-radius: 5px;
	margin-top: 10px;
	background-color: rgba(244, 250, 255, 1);
	height: 300px;
	overflow-y: scroll;
}

.w-25 {
	width: 25%;
}
.w-35 {
	width: 35%;
}

.w-40 {
	width: 40%;
}
</style>
